import { type ExtractPropTypes, defineComponent } from 'vue'

import { getSizeStyle, makeStringProp, numericProp } from '@xzx-design/utils'

import { Icon } from '@xzx-design/components/icon'
import { Pic } from '@xzx-design/icons-vue'
import { useNamespace } from '@xzx-design/hooks'

export type SkeletonImageShape = 'square' | 'round'

export const skeletonImageProps = {
  imageSize: numericProp,
  imageShape: makeStringProp<SkeletonImageShape>('square'),
}

export type SkeletonImageProps = ExtractPropTypes<typeof skeletonImageProps>

const name = 'XzxSkeletonImage'

export default defineComponent({
  name,
  __name: name,
  props: skeletonImageProps,
  setup(props) {
    const { bem } = useNamespace('skeleton-image')

    return () => (
      <div
        class={bem([props.imageShape])}
        style={getSizeStyle(props.imageSize)}
      >
        <Icon class={bem('icon')}>
          <Pic />
        </Icon>
      </div>
    )
  },
})
